module.exports = __webpack_public_path__ + "static/media/downloads.4e920d55.svg";